import fetchAction from 'utils/fetchAction';

import { REFER_FRIEND_SCRIBE_BASE_URL, customerPageType } from '../const';

export const FETCH_REFER_FRIEND_SCRIBE_REQUEST = 'FETCH_REFER_FRIEND_SCRIBE_REQUEST';
export const FETCH_REFER_FRIEND_SCRIBE_SUCCESS = 'FETCH_REFER_FRIEND_SCRIBE_SUCCESS';
export const FETCH_REFER_FRIEND_SCRIBE_ERROR = 'FETCH_REFER_FRIEND_SCRIBE_ERROR';

export const fetchReferFriendScribeContents = (customerPage = customerPageType.existing) => {
  const apiUrl = `${REFER_FRIEND_SCRIBE_BASE_URL}/${customerPage}`;

  return fetchAction({
    actions: [
      FETCH_REFER_FRIEND_SCRIBE_REQUEST,
      FETCH_REFER_FRIEND_SCRIBE_SUCCESS,
      FETCH_REFER_FRIEND_SCRIBE_ERROR,
    ],
    url: apiUrl,
  })();
};
